import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, message, DatePicker } from 'antd';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { _success, _setAxios, _validationFormMsg, _getDate } from '../../../../lib/Helper';

import "./style.css"

const { RangePicker } = DatePicker;

const schema = {
    tgl_awal: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
    tgl_akhir: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
    ruangan_id: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,

            visible: false,
            fileList: [],
            ddl: {
                ruangan: []
            }
        };
    }

    componentDidMount() {
        this.setState({
            values: this.props.data,
        })
        this.getRuanganDDL()
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        const errors = validate(values, schema);
        if (errors) {
            return _validationFormMsg(errors)
        }

        let tglAwal = _getDate(values.tgl_awal)
        let tglAkhir = _getDate(values.tgl_akhir)

        let _tglAwal = tglAwal.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");
        let _tglAkhir = tglAkhir.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");

        if (_tglAwal > _tglAkhir) {
            return message.warning("Periode yang dimasukkan tidak valid.");
        }

        this.setState({
            loading: true
        });
        const params = {
            ruangan_id: values.ruangan_id ? values.ruangan_id.id : null,
            tgl_awal: values.tgl_awal,
            tgl_akhir: values.tgl_akhir,
            keterangan: values.keterangan ? values.keterangan : null,
        }

        let endpoint = "sarpras/ruangan/booking"
        let method = "POST"
        if (values.id) {
            endpoint = "sarpras/ruangan/booking/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    getRuanganDDL = () => {
        _setAxios("ruangan/dropdown", "POST", {
            jenis_ruangan_id: "",
            is_booking: "0"
        }).then(resp => {
            if (resp.status === true) {
                this.setState({
                    ddl: {
                        ...this.state.ddl,
                        ruangan: resp.data.data
                    }
                });
            }
        })
    }

    render() {

        const { values, errors, ddl } = this.state

        return (
            <Modal
                maskClosable={false}
                title={"Form booking ruangan"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Simpan</Button>
                </>}
            >
                <Row gutter={[24, 24]}>
                    {!values.id ?
                        <Col xs={24}>
                            <RangePicker
                                showTime
                                style={{ width: '100%' }}
                                onChange={(e, newValue) => {
                                    if (newValue.length === 2 && (newValue[0] && newValue[1])) {
                                        this.handleChangeSetValue("tgl_awal", newValue[0])
                                        this.handleChangeSetValue("tgl_akhir", newValue[1])
                                    }
                                }}
                            />
                        </Col> :
                        <>
                            <Col xs={12}>
                                <TextField
                                    multiline
                                    fullWidth
                                    size="small"
                                    label="Waktu Mulai"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    type="text"
                                    disabled={true}
                                    value={values.tgl_awal || ''}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Col>
                            <Col xs={12}>
                                <TextField
                                    multiline
                                    fullWidth
                                    size="small"
                                    label="Waktu Selesai"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    type="text"
                                    disabled={true}
                                    value={values.tgl_akhir || ''}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Col>
                        </>
                    }
                    <Col xs={24}>
                        <Autocomplete
                            options={ddl.ruangan}
                            getOptionLabel={(option) =>
                                option.nama
                            }
                            renderInput={(params) => <TextField {...params}
                                fullWidth
                                label="Ruangan *"
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                name="ruangan_id"
                                type="text"
                                error={this.hasError('ruangan_id')}
                                helperText={
                                    this.hasError('ruangan_id') ? errors.ruangan_id[0] : null
                                }
                            />}
                            value={values.ruangan_id || null}
                            onChange={(e, newValue) => {
                                this.handleChangeSetValue("ruangan_id", newValue)
                            }}
                        />
                    </Col>
                    <Col xs={24}>
                        <TextField
                            multiline
                            fullWidth
                            label="Keterangan"
                            size="small"
                            minRows={3}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            name="keterangan"
                            type="text"
                            onChange={(e) => {
                                this.handleChangeSetValue("keterangan", e.target.value)
                            }}
                            value={values.keterangan || ''}
                            error={this.hasError('keterangan')}
                            helperText={
                                this.hasError('keterangan') ? errors.keterangan[0] : null
                            }
                        />
                    </Col>
                </Row>

            </Modal>
        )
    }
}

export default FormContent;
